// eslint-disable-next-line import/prefer-default-export
export const UPDATE_USER_SUCCESS = 'updateUserSuccess';
export const ACCEPT_COOKIES_M = 'acceptCookiesM';
